var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 46,
    viewBox: "0 0 50 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96942 46C3.86923 46 1.97954 44.9196 0.914286 43.1094C-0.150967 41.2995 -0.177997 39.1227 0.841795 37.2867L19.873 3.01801C20.9223 1.12832 22.839 0 25.0006 0C27.1623 0 29.079 1.12832 30.1283 3.01801L49.1595 37.2867C50.1788 39.1227 50.1514 41.2995 49.0866 43.1094C48.0213 44.9192 46.1316 46 44.0314 46H5.96942Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89469 37.8711L20.9259 3.60197C22.7017 0.404162 27.301 0.404162 29.0769 3.60197L48.1081 37.8711C49.8335 40.9784 47.5867 44.7962 44.0326 44.7962H5.97017C2.41605 44.7962 0.169235 40.9784 1.89469 37.8711Z",
    fill: "#F95858"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.21
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7907 43.2604C32.0097 38.0582 37.2139 32.8417 42.4156 27.6223L36.1875 16.4075C31.8176 20.7774 27.4472 25.1474 23.0773 29.5177C18.3096 34.2858 13.5416 39.0534 8.77398 43.821L7.79883 44.7962H25.2438C25.7586 44.2834 26.2763 43.7735 26.7907 43.2604Z",
    fill: "#CC1313"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.43
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.022 28.7151C40.7342 31.0106 38.4489 33.3087 36.1587 35.6018C33.094 38.6706 30.0256 41.7357 26.9531 44.7963H44.0316C47.5857 44.7963 49.8325 40.9784 48.1071 37.8711L43.0224 28.7151H43.022Z",
    fill: "#CC1313"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9501 31.6974L20.7275 18.1694V17.9143C20.7275 17.2659 21.253 16.7405 21.9013 16.7405H28.0991C28.7474 16.7405 29.2729 17.2659 29.2729 17.9143V18.1694L28.0234 31.6995C27.9701 32.2761 27.4864 32.7172 26.9073 32.7172H23.0661C22.4862 32.7172 22.0021 32.2749 21.9497 31.697L21.9501 31.6974ZM21.7563 38.0758V35.1905C21.7563 34.6929 22.1598 34.2895 22.6574 34.2895H27.3144C27.812 34.2895 28.2154 34.6929 28.2154 35.1905V38.0758C28.2154 38.5735 27.812 38.9769 27.3144 38.9769H22.6574C22.1598 38.9769 21.7563 38.5735 21.7563 38.0758Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.941b20e84f5b45faaecc43f71b674301.svg";
export { ForwardRef as ReactComponent };